module.exports = __webpack_public_path__ + "img/icon-light-startup-white.ce801400.svg";